import {
  FundingOptionsSectionedResult,
  FundingOptionsSectionedResultTypenames,
  FundingOriginInput,
} from '@varo/graphql-schema-types';
import fundingOptionsQuerySectioned from 'services/graphql/queries/onboarding/FundingOptionsSectioned.query';
import { useQuery } from 'urql';

const useGetFundingOptionsSectioned = ({
  origin,
}: {
  origin: FundingOriginInput;
}) => {
  const [{ data, error, fetching }] = useQuery<{
    fundingOptionsSectioned: FundingOptionsSectionedResult;
  }>({
    query: fundingOptionsQuerySectioned,
    variables: {
      input: {
        origin,
      },
    },
    requestPolicy: 'network-only',
  });

  const raw = data?.fundingOptionsSectioned;
  const fundingOptionsData =
    raw?.__typename ===
    FundingOptionsSectionedResultTypenames.FundingOptionsSectionedSuccess
      ? raw
      : undefined;
  const gqlError =
    raw?.__typename ===
    FundingOptionsSectionedResultTypenames.FundingOptionsError
      ? raw
      : undefined;

  return {
    fundingOptionsData,
    error: gqlError || error,
    fetching,
  };
};

export default useGetFundingOptionsSectioned;
